import React from 'react'

import '../styles/Footer.css'

const Footer = () => {
  return (
    <div className="footer">
      <div> Invitly © 2025</div>
    </div>
  )
}

export default Footer
